import { render, staticRenderFns } from "./Diacritics.vue?vue&type=template&id=874012ba&scoped=true&"
import script from "./Diacritics.vue?vue&type=script&lang=js&"
export * from "./Diacritics.vue?vue&type=script&lang=js&"
import style0 from "./Diacritics.vue?vue&type=style&index=0&id=874012ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874012ba",
  null
  
)

export default component.exports